module.exports = __webpack_public_path__ + "static/img/phone.4898ba6.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/phone.png
// module id = wW+f
// module chunks = 10